<div fxHide.gt-sm>
  <mat-toolbar>
    <div fxLayout="row" fxLayoutAlign="space-around center">
      <button mat-icon-button (click)="onToggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <span>Website Administrator</span>
    </div>
    <div fxFlex fxLayout fxLayoutAlign="end">
      <button mat-button [matMenuTriggerFor]="menu">User Name</button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <span>Change Password</span>
        </button>

        <button mat-menu-item>
          <mat-icon>exit_to_app</mat-icon>
          <span>Log out</span>
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
</div>
